import React from "react";
import PublicPage from "@/components/public/PublicPage";
import { UtensilsCrossed, Coffee, Truck, Factory, Hotel, School, ShoppingBasket, Beer } from "lucide-react";

const industries = [
  { name: "Restaurants", icon: UtensilsCrossed, desc: "Daily opening and closing checks, temperature logs and deviation handling." },
  { name: "Cafes and bakeries", icon: Coffee, desc: "Short routines that fit a fast service, completed on a phone." },
  { name: "Catering and events", icon: Truck, desc: "Transport, hot-holding and off-site service records." },
  { name: "Food manufacturing", icon: Factory, desc: "Structured HACCP control points with full traceable history." },
  { name: "Hotels", icon: Hotel, desc: "Multiple outlets and kitchens under one management dashboard." },
  { name: "Schools and care", icon: School, desc: "Consistent records across sites with clear staff responsibilities." },
  { name: "Retail and delis", icon: ShoppingBasket, desc: "Chilled display, storage and cleaning checks." },
  { name: "Bars and pubs", icon: Beer, desc: "Cellar, glasswash and kitchen checks in one place." },
];

export default function Industries() {
  return (
    <PublicPage
      eyebrow="Industries"
      title="Built for food businesses of every shape"
      intro="The same connected platform, with the checks and records that fit how each kind of food business actually runs."
    >
      <section className="relative">
        <div className="max-w-6xl mx-auto px-4 py-10 pb-20">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {industries.map(({ name, icon: Icon, desc }) => (
              <div key={name} className="app-card p-5">
                <div className="p-2.5 rounded-xl bg-crystal-orange/20 border border-crystal-orange/40 w-fit mb-3">
                  <Icon className="h-5 w-5 text-crystal-orange" />
                </div>
                <div className="text-white font-semibold">{name}</div>
                <p className="text-white/65 text-sm mt-1.5">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PublicPage>
  );
}
